module.exports = __webpack_public_path__ + "static/media/amwest.8e0c4542.png";